import React from "react";
import { Grid, Paper } from "@mui/material";
import { IVisitor } from '../../models/registrationModels';
import RsDataField from "./RsDataField";
import GridItemContainer from "../layout/GridItemContainer";

const RsVisitor = ({ visitor }: { visitor: IVisitor}) => {

  const getTravelDocumentString = (visitor: IVisitor) => {
    const values = [
      visitor.documentType,
      visitor.document,
      visitor.documentDate?.toFormattedDateOrDefault(),
      visitor.documentPlace
    ];
    const filteredValues = values.filter(v => v !== undefined && v !== null && v !== '');
    return filteredValues.join(', ');
  };
  return (
    <Paper elevation={2} sx={{overflow:"hidden"}}>
      <Grid container>
        <GridItemContainer border xs={6} md={4}>
          <RsDataField labelStrong="FAMILIENNAME" labelSmall="(last name)" value={visitor.name} />
        </GridItemContainer>
        <GridItemContainer border xs={6} md={4}>
          <RsDataField labelStrong="VORNAME" labelSmall="(first name)" value={visitor.prename} />
        </GridItemContainer>
        <GridItemContainer border xs={6} md={4}>
          <RsDataField labelStrong="ANREDE, TITEL" labelSmall="(salutation, title)" value={`${visitor.salutation}${visitor.title ? `, ${visitor.title}` : ''}`} />
        </GridItemContainer>
        <GridItemContainer border xs={6} md={4}>
          <RsDataField labelStrong="GESCHLECHT" labelSmall="(sex)" value={visitor.gender} />
        </GridItemContainer>
        <GridItemContainer border xs={6} md={4}>
          <RsDataField labelStrong="GEBURTSDATUM" labelSmall="(date of birth)" value={visitor.birthDate.toFormattedDateOrDefault()} />
        </GridItemContainer>
        <GridItemContainer border xs={6} md={4}>
          <RsDataField labelStrong="STAATSANGEHÖRIGKEIT" labelSmall="(nationality)" value={visitor.birthState} />
        </GridItemContainer>
        <GridItemContainer border xs={12}>
          <RsDataField
            labelStrong="REISEDOKUMENT bei ausländischen Gästen"
            labelSmall="(Art, Nummer, Ausstellungsdatum, austellende Behörde) (travel document)"
            value={getTravelDocumentString(visitor)}

          />
        </GridItemContainer>
        <GridItemContainer border isHeader xs={12}>
          <RsDataField labelStrong="HERKUNFTSLAND" labelSmall="und ADRESSE - Hauptwohnsitz oder gewöhnlicher Aufenthalt (country of origin and address)" isHeader />
        </GridItemContainer>
        <GridItemContainer border xs={12}>
          <RsDataField labelStrong="STRASSE/GASSE/PLATZ" labelSmall="(street/lane/square)" value={visitor.street} />
        </GridItemContainer>
        <GridItemContainer border xs={6} md={4}>
          <RsDataField labelStrong="POSTLEITZAHL" labelSmall="(ZIP Code)" value={visitor.zip} />
        </GridItemContainer>
        <GridItemContainer border xs={6} md={4}>
          <RsDataField labelStrong="ORT/GEMEINDE" labelSmall="(city/community)" value={visitor.city} />
        </GridItemContainer>
        <GridItemContainer border xs={12} md={4}>
          <RsDataField labelStrong="STAAT" labelSmall="(country)" value={visitor.state} />
        </GridItemContainer>
      </Grid >
    </Paper>
  );
};

export default RsVisitor;
